var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 62,
    viewBox: "0 0 53 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8644 10.1985C38.0731 7.63864 39.5619 4.07329 39.1545 0.525879C35.9717 0.647056 32.121 2.55908 29.8388 5.11589C27.7894 7.38491 26.0004 11.0104 26.4814 14.4882C30.0318 14.7517 33.6558 12.7613 35.8644 10.1985ZM43.8261 32.7137C43.9149 41.8836 52.2197 44.934 52.3116 44.9734C52.2442 45.1885 50.9852 49.3199 47.9371 53.5913C45.2996 57.2812 42.564 60.956 38.2539 61.0348C34.0203 61.1105 32.6571 58.6295 27.8139 58.6295C22.9738 58.6295 21.4605 60.9557 17.4537 61.1102C13.2936 61.2586 10.1231 57.1181 7.46713 53.4404C2.03273 45.9184 -2.11811 32.1838 3.4572 22.9138C6.22647 18.3122 11.1738 15.3937 16.5469 15.321C20.6304 15.2453 24.4871 17.954 26.9838 17.954C29.4804 17.954 34.1673 14.6974 39.0932 15.176C41.1549 15.2578 46.9446 15.9725 50.6604 21.1861C50.3602 21.3648 43.7526 25.0493 43.8261 32.7137Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany7);
export default __webpack_public_path__ + "static/media/company-7.bf2117011079508911b472548a7f0d47.svg";
export { ForwardRef as ReactComponent };